import React from 'react';

import { Reveal } from '../Reveal/Reveal';
import { Skeleton } from '../Skeleton/Skeleton';
import { Root, Label, Value, TONE_COLOR, type StatTone } from './StatCell.styles';

export { StatGrid, StatsWrap } from './StatCell.styles';
export type { StatTone };

export type StatCellProps = {
  label: string;
  value: string;
  /** Colour the value (e.g. positive/negative ROI). Defaults to neutral. */
  tone?: StatTone;
  /** While true, the value shows a sheen placeholder (the endpoint is loading). */
  loading?: boolean;
};

/**
 * A label + value pair — the atom of every stat row in the area (channel
 * campaign stats, affiliate cards, running-campaign hero, etc.). Wrap a set of
 * these in `<StatGrid $columns={n}>`. The label is static chrome; only the value
 * loads in (the placeholder lives inside `Value` so it inherits its font).
 */
export const StatCell = ({ label, value, tone = 'default', loading = false }: StatCellProps): React.ReactElement => (
  <Root>
    <Label text={label} tag="span" />
    <Value $color={TONE_COLOR[tone]}>
      <Reveal loading={loading} placeholder={<Skeleton width={`${Math.max(2, value.length)}ch`} height="0.8em" radius={5} />}>
        {value}
      </Reveal>
    </Value>
  </Root>
);

export default StatCell;
